/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_StopInputs */



/**
* | output |
* | --- |
* | "Stop" |
*
* @param {Assistant_StopInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_stop = /** @type {((inputs?: Assistant_StopInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_StopInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arrêt")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stoppen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fermare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Останавливаться")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detener")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("停止")
	if (locale === "ja") return /** @type {LocalizedString} */ ("停止")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रुकना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Parar")
	return /** @type {LocalizedString} */ ("Stop")
});